module.exports = __webpack_public_path__ + "static/media/s_sf_11.2ed31ba7.png";